/**
 * Silent Composite Report Definition default: first CRD that has template
 * sections, else first in the list. Callers must pass folder-walk order — do
 * not sort by recency.
 */
export function selectDefaultCrdId(
  compositeReportDefinitions: ReadonlyArray<{ durableId: string }>,
  hasTemplateSections: (durableId: string) => boolean | undefined,
): string | undefined {
  const firstWithSections = compositeReportDefinitions.find(
    crd => hasTemplateSections(crd.durableId) === true,
  );
  if (firstWithSections) {
    return firstWithSections.durableId;
  }
  return compositeReportDefinitions[0]?.durableId;
}
